<ion-item my-item="" text-center lines="none">
  <ion-grid no-padding>
    <ion-row no-padding>
      <ion-col no-padding size="12">
        <ion-icon
          [color]="selectedLocationId === locationItem.id ? 'light' : 'none'"
          text-center
          [src]="'./assets/store.svg'"
          style="font-size: 36px"
        ></ion-icon>
      </ion-col>
      <ion-col size="12" class="location-name" text-center no-padding>
        <ion-text
          [ngClass]="
            selectedLocationId === locationItem.id
              ? 'after-selection-color'
              : 'before-selection-title'
          "
          text-center
        >
          {{ locationItem.name }}
        </ion-text>
      </ion-col>
      <ion-col size="12" class="location-addr" no-padding padding-horizontal>
        <ion-text
          text-center
          [ngClass]="
            selectedLocationId === locationItem.id
              ? 'after-selection-color'
              : 'before-selection-street'
          "
        >
          <span
            >{{ locationItem?.addressInfo?.flatBuilding }},
            {{ locationItem?.addressInfo?.street }}</span
          >
        </ion-text>
      </ion-col>
    </ion-row>
  </ion-grid>
  <ion-radio
    (ionSelect)="onItemSelect(locationItem)"
    [value]="locationItem.id"
  ></ion-radio>
  <ion-icon
    class="check-mark-position"
    color="primary"
    [name]="'checkmark-circle'"
    slot="end"
  ></ion-icon>
</ion-item>
